"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
Object.defineProperty(exports, "__esModule", { value: true });
var EulerSpeechType;
(function (EulerSpeechType) {
    EulerSpeechType[EulerSpeechType["GOOD"] = 0] = "GOOD";
    EulerSpeechType[EulerSpeechType["BAD"] = 1] = "BAD";
})(EulerSpeechType = exports.EulerSpeechType || (exports.EulerSpeechType = {}));
var EulerOptionType;
(function (EulerOptionType) {
    EulerOptionType[EulerOptionType["DEAULT"] = 0] = "DEAULT";
    // 学业
    EulerOptionType[EulerOptionType["ACADEMIC_PERCEPTUAL_MEMORY"] = 1] = "ACADEMIC_PERCEPTUAL_MEMORY";
    EulerOptionType[EulerOptionType["ACADEMIC_UNDERSTANDING_ANALYSIS"] = 2] = "ACADEMIC_UNDERSTANDING_ANALYSIS";
    EulerOptionType[EulerOptionType["ACADEMIC_LOGICAL_REASONING"] = 3] = "ACADEMIC_LOGICAL_REASONING";
    EulerOptionType[EulerOptionType["ACADEMIC_LANGUAGE_EXPRESSION"] = 4] = "ACADEMIC_LANGUAGE_EXPRESSION";
    // 健康
    EulerOptionType[EulerOptionType["HEALTH_MOTION"] = 5] = "HEALTH_MOTION";
    EulerOptionType[EulerOptionType["HEALTH_POSITIVE"] = 6] = "HEALTH_POSITIVE";
    // 人际
    EulerOptionType[EulerOptionType["INTERPERSONAL_OUTWARD"] = 7] = "INTERPERSONAL_OUTWARD";
    EulerOptionType[EulerOptionType["INTERPERSONAL_INITIATIVE"] = 8] = "INTERPERSONAL_INITIATIVE";
    // 眼界
    EulerOptionType[EulerOptionType["VISION_OPEN"] = 9] = "VISION_OPEN";
    EulerOptionType[EulerOptionType["VISION_MULTIPLE"] = 10] = "VISION_MULTIPLE";
})(EulerOptionType = exports.EulerOptionType || (exports.EulerOptionType = {}));
exports.EULER_SUMMARY = (_a = {},
    _a[EulerOptionType.DEAULT] = ['完美的避开所有共同点', '百分百互为补角，实为罕见'],
    _a[EulerOptionType.ACADEMIC_PERCEPTUAL_MEMORY] = ['TA们都记得快学得快', 'TA们学过的东西不会轻易忘记'],
    _a[EulerOptionType.ACADEMIC_UNDERSTANDING_ANALYSIS] = ['TA们理解能力一级棒', 'TA们学习都不太费劲儿'],
    _a[EulerOptionType.ACADEMIC_LOGICAL_REASONING] = ['TA们都是未来学霸候选', 'TA脑袋瓜都转的特别快'],
    _a[EulerOptionType.ACADEMIC_LANGUAGE_EXPRESSION] = ['TA们都是语言的艺术家', 'TA们都能言善辩会表达'],
    _a[EulerOptionType.HEALTH_MOTION] = ['TA们都是运动小能手', 'TA们浑身都是能量'],
    _a[EulerOptionType.HEALTH_POSITIVE] = ['TA们都是正能量的小宝贝', 'TA们常常能用快乐感染别人'],
    _a[EulerOptionType.INTERPERSONAL_OUTWARD] = ['TA们都活泼可爱受欢迎', 'TA们都古灵精怪外向开朗'],
    _a[EulerOptionType.INTERPERSONAL_INITIATIVE] = ['TA们做什么都充满干劲', 'TA们都是人群的小中心'],
    _a[EulerOptionType.VISION_OPEN] = ['TA们都思维灵活爱探索', 'TA们都眼界开阔视野广'],
    _a[EulerOptionType.VISION_MULTIPLE] = ['TA们都兴趣多爱好广', 'TA们都多才多艺多潜能'],
    _a);
exports.EULER_WHISPER = (_b = {},
    _b[EulerOptionType.DEAULT] = ['两家人常来常往，有利于提高宝贝合拍指数哦~'],
    _b[EulerOptionType.ACADEMIC_PERCEPTUAL_MEMORY] = [
        '下次见面比赛背圆周率，指不定谁家能赢呢~',
        '背诗词没在怕的，下次见面PK一把！',
    ],
    _b[EulerOptionType.ACADEMIC_UNDERSTANDING_ANALYSIS] = [
        '别担心TA们上课听不懂，只要有认真听',
        '有的宝贝学习时读题费劲，TA俩不太会有这个问题~',
    ],
    _b[EulerOptionType.ACADEMIC_LOGICAL_REASONING] = [
        '文笔如何还未可知，但作文布局一定逻辑清爽有条理。',
        '都是灵活、不墨守成规，会举一反三、不死脑筋的小学霸。',
    ],
    _b[EulerOptionType.ACADEMIC_LANGUAGE_EXPRESSION] = [
        '一个口才好一个文笔强，今年也要一起加油哦~',
        '可以考虑培养宝贝们在演讲和辩论方面的才能哦~',
    ],
    _b[EulerOptionType.HEALTH_MOTION] = ['即使他们经常打架，但马上就能和好~', '一起报个运动兴趣班吧，肯定能玩儿到一起~'],
    _b[EulerOptionType.HEALTH_POSITIVE] = [
        '每次一起玩都能开心收尾，偶尔闹别扭也不怕~',
        '一定是满满正能量的家长，才能培养出这么棒的宝贝！',
    ],
    _b[EulerOptionType.INTERPERSONAL_OUTWARD] = [
        '有时候是不是也希望TA俩能稍微“佛系”一些？',
        '两颗能量团放在一起，大人们才能好好放个空呀~',
    ],
    _b[EulerOptionType.INTERPERSONAL_INITIATIVE] = [
        '两位宝贝今年都是热门班长候选，应该不在同一个班吧？',
        '胆子大又有礼貌，“爱表现”的宝贝总是特别招人喜欢~',
    ],
    _b[EulerOptionType.VISION_OPEN] = [
        '哪怕是周边短途，今年一起筹备一场家庭游吧！',
        '偶尔让人觉得有些淘气，殊不知越“难带”的宝贝越聪明。',
    ],
    _b[EulerOptionType.VISION_MULTIPLE] = [
        '兴趣爱好这么多，你家宝贝最擅长哪个？',
        '春暖花开的时候，相约一场与樱花的约会吧~',
    ],
    _b);
exports.EULER_OWNER_SUMMARY = (_c = {},
    _c[EulerOptionType.ACADEMIC_PERCEPTUAL_MEMORY] = (_d = {},
        _d[EulerSpeechType.GOOD] = ['有机会练就过目不忘的本领；', '总能发现生活中的小细节；', '喜欢观察生活中的点点滴滴；'],
        _d[EulerSpeechType.BAD] = [
            '家长可以加强对宝贝记忆力的锻炼，激发孩子潜能。',
            '可能会有点丢三落四，家长要提醒宝贝多细心一些~',
        ],
        _d),
    _c[EulerOptionType.ACADEMIC_UNDERSTANDING_ANALYSIS] = (_e = {},
        _e[EulerSpeechType.GOOD] = ['理解吸收特别快，学习轻松；', '反应迅速，能够举一反三；'],
        _e[EulerSpeechType.BAD] = [
            '家长可以对宝贝多提一些“为什么”，引导宝贝勤思考多探索~',
            '家长可以多引导宝贝养成阅读习惯，激发宝贝理解和分析潜力。',
        ],
        _e),
    _c[EulerOptionType.ACADEMIC_LOGICAL_REASONING] = (_f = {},
        _f[EulerSpeechType.GOOD] = [
            '谋定而后动，总会做好充分准备；',
            '善于储备知识，非常有条理计划；',
            '判断力强，非常有主见；',
            '做事严谨，不丢三落四；',
        ],
        _f[EulerSpeechType.BAD] = [
            '家长可以引导宝贝进行有目的性的写作，让宝贝养成书写习惯。',
            '家长可以多告诉宝贝一些“为什么”，建立宝贝的逻辑能力。',
            '家长可以多带宝贝做一些找规律类的小游戏，培养宝贝的推理能力。',
        ],
        _f),
    _c[EulerOptionType.ACADEMIC_LANGUAGE_EXPRESSION] = (_g = {},
        _g[EulerSpeechType.GOOD] = [
            '总能非常主动的表达自己的想法；',
            '看图说话一级棒，总有奇思妙语；',
            '能够很快的理解别人并作出反应；',
        ],
        _g[EulerSpeechType.BAD] = [
            '家长可以经常带宝贝出去走走，多给宝贝提供表达观点的机会。',
            '简单的口头赞美都是宝贝继续学习的动力，家长一定要多鼓励宝贝~',
            '家长可以每天抽点时间和宝贝一起读书，提升宝贝的语言表达能力。',
        ],
        _g),
    _c[EulerOptionType.HEALTH_MOTION] = (_h = {},
        _h[EulerSpeechType.GOOD] = ['总是充满活力，精气神儿饱满；', '身体棒棒，永远保持满满能量；'],
        _h[EulerSpeechType.BAD] = [
            '家长可以多带宝贝到户外走走，让宝贝多做运动少生病。',
            '家长要做好宝贝的榜样，从简单有趣的运动开始，带宝贝爱上运动。',
        ],
        _h),
    _c[EulerOptionType.HEALTH_POSITIVE] = (_j = {},
        _j[EulerSpeechType.GOOD] = [
            '做什么都信心满满，勇于挑战；',
            '好心态决定了TA的高幸福指数；',
            '发挥型选手，常能超水平得高分；',
        ],
        _j[EulerSpeechType.BAD] = [
            '家长要更加信任宝贝，让宝贝偶尔的小自卑走开。',
            '家长可以多用积极的语言引导宝贝，让宝贝变得更加自信~',
        ],
        _j),
    _c[EulerOptionType.INTERPERSONAL_OUTWARD] = (_k = {},
        _k[EulerSpeechType.GOOD] = ['总是人群中的小焦点；', '嘴甜的交际小能手，总是很吃香；', '与生俱来的社交能力；'],
        _k[EulerSpeechType.BAD] = [
            '懂得倾听他人的贴心宝贝，家长可以引导孩子加强人际交往能力。',
            '自律且内心生活丰富，可以多带宝贝出去开阔视野，认识新朋友。',
        ],
        _k),
    _c[EulerOptionType.INTERPERSONAL_INITIATIVE] = (_l = {},
        _l[EulerSpeechType.GOOD] = ['只要一提醒就能去主动学习；', '不拖拉、学习效率高；', '爱钻研思考，能做好自己的事情；'],
        _l[EulerSpeechType.BAD] = [
            '可以多让宝贝掌握自己的思想，让宝贝有更多的好奇心和探索心。',
            '可以多给宝贝选择自己物品的权力，让宝贝在选择中更加了解自己。',
            '可以多听宝贝的想法，鼓励宝贝大胆的去探索，满足宝贝的求知欲。',
        ],
        _l),
    _c[EulerOptionType.VISION_OPEN] = (_m = {},
        _m[EulerSpeechType.GOOD] = ['总能提出一些有趣的好问题；', '脑袋里装着十万个为什么；', '学习时就像海绵，一教就会；'],
        _m[EulerSpeechType.BAD] = [
            '家长要多问宝贝“填空题”，减少“选择题”，让宝贝思维更活跃。',
            '宝贝的可塑性很强，家长一定要做好引导，以免呈现两极化表现哦~',
        ],
        _m),
    _c[EulerOptionType.VISION_MULTIPLE] = (_o = {},
        _o[EulerSpeechType.GOOD] = ['宝贝的优势潜能很多；', '潜在的天才，拥有多方面潜能；', '宝贝的兴趣爱好非常广泛；'],
        _o[EulerSpeechType.BAD] = [
            '家长可以给宝贝提供各种机会多多尝试，发展宝贝多元潜能。',
            '家长要尊重宝贝的学习方式和速度，学会用赞赏的眼光看宝贝。',
        ],
        _o),
    _c);
var SubscribeAndScanAction;
(function (SubscribeAndScanAction) {
    SubscribeAndScanAction[SubscribeAndScanAction["JOIN_FREE_LESSON_GROUP"] = 0] = "JOIN_FREE_LESSON_GROUP";
    SubscribeAndScanAction[SubscribeAndScanAction["CREATE_FREE_LESSON_GROUP"] = 1] = "CREATE_FREE_LESSON_GROUP";
    SubscribeAndScanAction[SubscribeAndScanAction["EULER_MATCH_FORTUNE_WITH_FRIEND"] = 2] = "EULER_MATCH_FORTUNE_WITH_FRIEND";
    SubscribeAndScanAction[SubscribeAndScanAction["EULER_SCAN_QUIZ_QR"] = 3] = "EULER_SCAN_QUIZ_QR";
})(SubscribeAndScanAction = exports.SubscribeAndScanAction || (exports.SubscribeAndScanAction = {}));
//# sourceMappingURL=euler.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/euler.js
// module id = 1001
// module chunks = 0